export interface ProjectFlowNodeLock {
  clientId: number;
  userId: string;
  name: string;
}

export function canWriteClaimedProjectFlowNode({
  localClientId,
  remoteLock,
  now,
  readyAt,
}: {
  localClientId: number;
  remoteLock?: ProjectFlowNodeLock;
  now: number;
  readyAt: number;
}) {
  if (now < readyAt) {
    return false;
  }
  return !remoteLock || localClientId < remoteLock.clientId;
}

export function getRemoteProjectFlowNodeLocks(
  states: Array<[number, any]>,
  localClientId: number
) {
  return states.reduce<Record<string, ProjectFlowNodeLock>>(
    (locks, [clientId, state]) => {
      const nodeId = String(state?.dragging?.nodeId || "");
      if (clientId === localClientId || !nodeId) {
        return locks;
      }
      if (locks[nodeId] && locks[nodeId].clientId < clientId) {
        return locks;
      }
      locks[nodeId] = {
        clientId,
        userId: String(state?.user?.userId || ""),
        name: String(state?.user?.name || state?.user?.userId || "协作者"),
      };
      return locks;
    },
    {}
  );
}
